import { useDroppable } from '@dnd-kit/core';
import { SortableItem } from './SortableItem';
import { SortableContext, rectSortingStrategy } from '@dnd-kit/sortable';//verticalListSortingStrategy

// --- Droppable Container Component ---
export function Container({ id, items, isGreen }) {
    const { setNodeRef } = useDroppable({ id });
    const containerStyle = {
        border: `3px dashed ${isGreen ? 'green' : 'grey'}`,
        backgroundColor: isGreen ? '#f0fff0' : '#949494',
        padding: '15px',
        margin: '15px',
        minHeight: '240px',
        width: '226px',
        borderRadius: '10px',
    };
    const gridStyle = {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(70px, 1fr))',
        gap: '8px',
        minHeight: '100%', // Fill the container
        width: '100%'
    };
    return (
        // The outer div is the droppable area
        <div ref={setNodeRef} style={containerStyle}>
            {/* SortableContext should wrap the items but not necessarily be the droppable ref */}
            <SortableContext
                id={id}
                items={items}
                strategy={rectSortingStrategy}
            >
                {/* Separate grid container for layout */}
                <div style={gridStyle}>
                    {items.map(itemId => (
                        <SortableItem key={itemId} id={itemId} />
                    ))}
                </div>
            </SortableContext>
        </div>
    );
}